export default "__VITE_ASSET__COsLJFw4__";